export const convertTimeStampToDateTimeString = (isoString: string, use24Hour = false) => {

  try {
    const date = new Date(isoString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: use24Hour ? '2-digit' : 'numeric',
      minute: '2-digit',
      hour12: !use24Hour,
    };

    const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

    return formattedDate.replace(/,([^,]*)$/, ' at$1');
  } catch {
    return '';
  }
};
